import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAlert from '../../hooks/useAlert';
import { onClickEvent } from '../../lib/gaAnalytics';
import { useAuth } from '../../contexts/auth';
import {
  CreateTicket,
  GetDispoDetials,
  handleImpressionsTrack,
  uploadFiles,
  checkNoLeads,
  GetTicketPayexecDetails,
  getMobileBusiness,
  sendCommunicationDB,
  saveTicketData,
} from '../../api';
import { useAppState } from '../../contexts/appState';
import { handleLoginPopup, handleSetTicketsData } from '../../reducersAndActions/actions/appStateActions';
import {
  checkEngChars,
  CheckingValidComment,
  clickTracker,
  getCommentErrorMsg,
  getProjectId,
  getSourceValue,
  hasJdMartVertical,
  andriodSource,
  iosSource,
  getCookie,
  cancellationReasons,
  ChangeFirstLetterCapital,
  allVerticalsParam,
  complaintReasonList,
  removeListingReasonList,
  empList,
} from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import '../../styles/ticketCreate.css';
import SubComplaintType from './SubComplaintType';
import TicketSuccessModal from '../../components/Genio/TicketSuccessModal/TicketSuccessModal';
import style from './TicketCreate.module.scss';

const issueTagging = {
  'Activation-Deactivation': 'CONTRACT RELATED',
  'Edit-my-Business': 'DATA CHANGES/VALIDATION REQUEST',
  Leads: 'LEADS',
  Payments: 'PAYMENTS & REFUNDS',
  ECS: 'ECS',
  'Contract-Information': 'CONTRACT RELATED',
  'Website-App-Related': 'OTHER ISSUES',
  'Banner-JDRR': 'BANNER RELATED',
  'JD-Pay': 'JD PAY',
  ecs: 'ECS',
  jd_pay: 'JD PAY',
  activation_deactivation: 'CONTRACT RELATED',
  edit_my_business: 'DATA CHANGES/VALIDATION REQUEST',
  payments: 'PAYMENTS & REFUNDS',
  website_app_related: 'OTHER ISSUES',
  contract_information: 'CONTRACT RELATED',
  leads: 'LEADS',
  banner_jdrr: 'BANNER RELATED',
  'Mobile Banner': 'MOBILE BANNER RELATED',
  'Web Banner': 'WEB BANNER RELATED',
  'JDRR Certificate': 'BANNER RELATED',
  UBL: 'UBL RELATED',
  LeadBank: 'LEAD BANK - B2B',
  SmartAssistant: 'SMART ASSISTANT',
  jiohotstar: 'JIO-HOTSTAR CAMPAIGN',
  bookAppointment: 'BOOK APPOINTMENT',
};

const formatDate = (date) => {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

const EXCLUDED_EMP_NAMES = new Set(['auto_classify_process', 'AI Bot2', 'AI Bot']);

export default function TicketCreate() {
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const queryParams = new URLSearchParams(window.location.search);
  const [authState] = useAuth();
  const parentId = queryParams.get('parentId') || authState.selectedBusiness.parentid;
  const [, appDispatch] = useAppState();
  const [allBusinesses, setAllBusinesses] = useState(authState.allBusinesses || []);

  const navigate = useNavigate();
  const exitPopupFlag = queryParams.get('exitPopupFlag');
  const projectId = getProjectId();
  const [fileData, setFileData] = useState([]);
  const [setAlert] = useAlert();
  const [loading, setLoading] = useState(false);
  const [issueComment, setIssueComment] = useState('');
  const [dispositionData, setDispositionData] = useState([]);
  const [haveSubmitted, setHaveSubmitted] = useState(false);
  const [genioSuccessTicketId, setGenioSuccessTicketId] = useState(null);
  // ECS STOP - Reasons Dropdown
  const [cancellationReason, setCancellationReason] = useState('');
  // const createTicketFlag = queryParams.get('createTicket') || '';
  const raiseTicketTrackerID = queryParams?.get('raiseTicketTrackerID');
  const token = queryParams.get('token') || '';
  const onboardingRedirectUrl = queryParams.get('redirectUrl') || '';
  // Logic for Auto Complete Search
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIssueSubIssue, setSelectedIssueSubIssue] = useState({
    selectedIssue: issueTagging[queryParams?.get('key')] ? issueTagging[queryParams?.get('key')] : '',
    selectedSubIssue: '',
    selectedOption: '',
  });
  const [issueSubIssueData, setIssueSubIssueData] = useState({
    issueData: selectedIssueSubIssue?.selectedIssue ? [selectedIssueSubIssue.selectedIssue] : ['Select Complaint'],
    subIssueData: ['Select Complaint Type'],
  });
  const [selectedBusinessObj, setSelectedBusinessObj] = useState({});
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [issuesDisplayObj, setIssuesDisplayObj] = useState({});
  const [bannerTicketCreateFlag, setBannerTicketCreateFlag] = useState(false);
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [subComplaintsData, setSubComplaintsData] = useState([]);
  const [selectedNotModifyTypeArr, setSelectedNotModifyTypeArr] = useState([]);
  const [showSubComplaintType, setShowSubComplaintType] = useState(false);
  const [enableSubComplaintBtn, setEnableSubComplaintBtn] = useState(false);
  const [modifyDataObj, setModifyDataObj] = useState({});
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [focusedItemIndex, setFocusedItemIndex] = useState(null);
  const wrapperRefs = useRef([]);
  const [displayAlert, setDisplayAlert] = useState(false);
  const [leadDetails, setLeadDetails] = useState({});
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [complaintRegarding, setComplaintRegarding] = useState(null);
  const [complaintReason, setComplaintReason] = useState('');
  const [selectedBusinessToRemove, setSelectedBusinessToRemove] = useState(null);
  const [removeListingReason, setRemoveListingReason] = useState('');
  const [businessListingDropdownOpen, setBusinessListingDropdownOpen] = useState(false);
  const businessListingRef = useRef(null);
  const [dynamicComplaintRegardingList, setDynamicComplaintRegardingList] = useState([
    { id: 'other', name: 'Other', role: '' },
  ]);

  const source = getSourceValue();
  const options = ['Self', 'Client'];
  const concernOptionsDisplay = {
    Self: 'No Callback Required',
    Client: 'Callback to Client',
  };
  const concernOptionsTooltip = {
    Self: 'CS will not initiate a call',
    Client: 'CS will call the client',
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRefs.current.every((ref) => ref && !ref.contains(event.target))) {
        setOpenDropdownIndex(null);
        setSearchTerm('');
      }
      if (businessListingRef.current && !businessListingRef.current.contains(event.target)) {
        setBusinessListingDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (selectedIssueSubIssue.selectedSubIssue !== 'NO LEADS RECEIVED') setDisplayAlert(false);
  }, [selectedIssueSubIssue.selectedIssue, selectedIssueSubIssue.selectedSubIssue]);

  useEffect(() => {
    setIssueComment('');
  }, [complaintReason, removeListingReason, cancellationReason, complaintRegarding, selectedBusinessToRemove]);

  const showCancellationReason =
    (selectedIssueSubIssue.selectedIssue === 'ECS' || selectedIssueSubIssue.selectedIssue === 'ecs') &&
    selectedIssueSubIssue.selectedSubIssue === 'STOP ECS';

  const getSubIssueData = (dispoData) => {
    if (dispoData && dispoData.length > 0 && issueTagging[queryParams?.get('key')]) {
      const subIssueRes = dispoData.filter((each) => {
        if (each.issue_type === issueTagging[queryParams?.get('key')]) {
          return each;
        }
        return null;
      });

      const subIssueDataRes =
        subIssueRes &&
        subIssueRes[0] &&
        Object.keys(subIssueRes[0]).length > 0 &&
        subIssueRes[0]?.disp_obj &&
        Object.keys(subIssueRes[0]?.disp_obj).length > 0
          ? subIssueRes[0]?.disp_obj
          : {};
      return subIssueDataRes;
    }
    return [];
  };

  const handleResetFormFields = () => {
    const subIssueData = getSubIssueData(dispositionData);
    setSelectedIssueSubIssue({
      selectedIssue: issueTagging[queryParams?.get('key')] ? issueTagging[queryParams?.get('key')] : '',
      selectedSubIssue: '',
    });
    const updtSubIssueData = Object.keys(subIssueData).map((eachKey) => eachKey.trim());
    setIssueSubIssueData({
      ...issueSubIssueData,
      subIssueData: ['Select Complaint Type', ...updtSubIssueData] || [],
    });
    setIssueComment('');
    setSearchTerm('');
  };

  useEffect(() => {
    if (authState?.allBusinesses?.length > 0 && projectId !== 'genio') {
      setAllBusinesses(authState.allBusinesses);
    }
  }, [authState?.allBusinesses, projectId]);

  useEffect(() => {
    const fetchBusinesses = async () => {
      if (selectedBusinessGenio && selectedBusinessGenio?.mobile) {
        try {
          const res = await getMobileBusiness(selectedBusinessGenio?.mobile);
          if (res && res.errorCode === 0 && res.result) {
            const data = res.result || [];
            if (projectId === 'genio') {
              setAllBusinesses(data);
            }
          }
        } catch (error) {
          console.log('Error fetching businesses: ', error);
        }
      }
    };
    fetchBusinesses();
  }, [selectedBusinessGenio?.mobile, projectId]);

  useEffect(() => {
    const handleSetBusinessObj = async () => {
      if (projectId === 'csportal') {
        if (allBusinesses?.length > 0 && parentId) {
          let businessFound = false;
          allBusinesses.forEach((business) => {
            if (business?.parentid === parentId) {
              businessFound = true;
              setSelectedBusinessObj(business || {});
            }
          });

          if (!businessFound) {
            handleLoginPopup(appDispatch, {
              open: true,
              desc: "It looks like you've logged in with different mobile number, please login with your required registered mobile number.",
              login: false,
            });
          }
        }
      }
    };
    handleSetBusinessObj();
  }, [selectedBusiness?.docid, allBusinesses]);

  useEffect(() => {
    const handleGetIssueSubIssues = async () => {
      const dispoParams = {
        category: 'cs',
        vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'listing',
        ticketCreator: 'business',
        docid: selectedBusiness?.docid,
      };

      try {
        const res = await GetDispoDetials(dispoParams, 1, projectId);
        setDispositionData(res || []);
        const dispoData = res || [];
        const issueDataRes = dispoData && dispoData.length > 0 ? res.map((each) => each.issue_type) : [];
        const subIssueData = getSubIssueData(dispoData);
        const updtSubIssueData = Object.keys(subIssueData).map((eachKey) => eachKey.trim());
        const upd = Object.fromEntries(Object.entries(subIssueData).map(([key, val]) => [key.trim(), val]));
        setIssuesDisplayObj(upd || {});
        setIssueSubIssueData({
          ...issueSubIssueData,
          issueData: ['Select Complaint', ...issueDataRes],
          subIssueData: ['Select Complaint Type', ...updtSubIssueData] || [],
        });
      } catch (err) {
        console.log('Error: ', err);
      }
    };
    handleGetIssueSubIssues();
  }, [selectedBusiness?.docid]);

  const isSalesComplaintStaff =
    selectedIssueSubIssue.selectedIssue === 'COMPLAINT-SALES TEAM' &&
    selectedIssueSubIssue.selectedSubIssue?.includes('COMPLAINT AGAINST A JUSTDIAL EXECUTIVE');

  useEffect(() => {
    const fetchTickets = async () => {
      if (!isSalesComplaintStaff) return;

      const today = new Date();
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      const startDateVal = formatDate(oneMonthAgo);
      const endDateVal = formatDate(today);

      const targetCity =
        projectId === 'csportal'
          ? selectedBusinessObj?.data_city || selectedBusiness?.data_city || selectedBusiness?.city || ''
          : selectedBusinessGenio?.city || '';
      const targetParentId =
        parentId ||
        selectedBusinessObj?.parentid ||
        selectedBusiness?.parentid ||
        selectedBusinessGenio?.parentId ||
        '';

      try {
        const ticketParams = {
          limit: 10,
          category: 'CS',
          vertical: allVerticalsParam,
          page: 1,
          portalFlag: 1,
          projectId,
          download: 0,
          data_city: targetCity,
          parentid: targetParentId,
          search: {
            docId: selectedBusiness?.docid || '',
            strtDate: startDateVal,
            endDt: endDateVal,
            city: targetCity,
            parentId: targetParentId,
          },
        };
        const res = await GetTicketPayexecDetails(ticketParams);
        const ticketsList =
          res?.ticketDetails?.data ||
          res?.ticketDetails ||
          (Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []);
        const payexecList =
          res?.payexecDetails?.data ||
          res?.payexecDetails?.results ||
          (Array.isArray(res?.payexecDetails) ? res.payexecDetails : []);

        const empNameMap = new Map();

        if (Array.isArray(ticketsList) && ticketsList.length > 0) {
          ticketsList.forEach((ticket) => {
            const name = ticket?.alloc_empnm?.trim();
            if (!name || EXCLUDED_EMP_NAMES.has(name)) return;
            if (!empNameMap.has(name)) {
              empNameMap.set(name, {
                id: name,
                name,
                empid: ticket?.alloc_empid || '',
                role: '',
                issue_sub_type: ticket?.issue_sub_type || '',
                date: ticket?.cr_on
                  ? new Date(ticket.cr_on.replace(' ', 'T')).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    })
                  : '',
              });
            }
          });
        }

        if (Array.isArray(payexecList) && payexecList.length > 0) {
          payexecList.forEach((exec) => {
            const name = (
              exec?.empname ||
              exec?.emp_name ||
              exec?.alloc_empnm ||
              exec?.name ||
              exec?.sales_exec ||
              ''
            ).trim();
            const empid = exec?.empid || exec?.emp_id || exec?.alloc_empid || exec?.empcode || exec?.emp_code || '';
            if (!name || EXCLUDED_EMP_NAMES.has(name)) return;
            if (!empNameMap.has(name)) {
              empNameMap.set(name, {
                id: name,
                name,
                empid,
                role: 'Sales Representative',
                issue_sub_type: '',
                date:
                  exec?.entry_date || exec?.cr_on
                    ? new Date((exec?.entry_date || exec?.cr_on).replace(' ', 'T')).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      })
                    : '',
              });
            }
          });
        }

        const payexecObj = res?.payexecDetails;
        if (payexecObj && typeof payexecObj === 'object' && !Array.isArray(payexecObj)) {
          // ME — show only if both code and name exists
          const meName = payexecObj?.meName?.trim();
          const mecode = payexecObj?.mecode?.trim();
          if (meName && mecode && !EXCLUDED_EMP_NAMES.has(meName) && !empNameMap.has(meName)) {
            empNameMap.set(meName, {
              id: meName,
              name: meName,
              empid: mecode,
              role: 'Sales Representative',
              issue_sub_type: '',
              date: '',
            });
          }

          // TME — show only if both code and name exists
          const tmeName = payexecObj?.tmeName?.trim();
          const tmecode = payexecObj?.tmecode?.trim();
          if (tmeName && tmecode && !EXCLUDED_EMP_NAMES.has(tmeName) && !empNameMap.has(tmeName)) {
            empNameMap.set(tmeName, {
              id: tmeName,
              name: tmeName,
              empid: tmecode,
              role: 'Sales Representative',
              issue_sub_type: '',
              date: '',
            });
          }
        }

        if (empNameMap.size > 0) {
          const empList = Array.from(empNameMap.values());
          const salesReps = empList.filter((emp) => emp.role === 'Sales Representative');
          const others = empList.filter((emp) => emp.role !== 'Sales Representative');
          setDynamicComplaintRegardingList([
            ...salesReps,
            ...others,
            { id: 'other', name: 'Other', role: '', issue_sub_type: '', date: '' },
          ]);
        }
      } catch (err) {
        console.log('Error fetching tickets/payexec details: ', err);
      }
    };
    fetchTickets();
  }, [selectedBusiness?.docid, selectedBusinessObj, parentId, isSalesComplaintStaff]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const sizeInKB = (file.size / 1024).toFixed(2);
    onClickEvent(`CS-Create Ticket Page`, 'Attachment Uploaded', `Attachment Uploaded ${(file && file?.type) || ''}`);
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      const tempFileData = [...fileData];
      try {
        setLoading(true);
        const response = await uploadFiles(files, true);
        if (response.error_code === 0) {
          if (response.image_urls && response.image_urls.length > 0) {
            tempFileData.push({ name: files[0].name, url: response.image_urls[0], size: `${sizeInKB} Kb` });
            setFileData(tempFileData);
          }
        } else {
          setAlert({
            message: 'Invalid file format',
            status: false,
          });
        }
        setLoading(false);
      } catch (err) {
        console.log('Error: ', err);
      }
    } else {
      setAlert({
        message: 'Accepts only image file',
        status: false,
      });
    }
  };

  const getSourceParamVal = (isRetentionVertical) => {
    let sourceVal = '';
    if (projectId === 'genio' && token) {
      sourceVal = 'onboardingmodule_genioticket';
    } else if (raiseTicketTrackerID === 'landing') {
      sourceVal = 'getacallback_landing';
    } else {
      sourceVal =
        exitPopupFlag === '1'
          ? isRetentionVertical
            ? `exit pop up_raise a ticket button_${projectId}`
            : `exit pop up_submitbutton_${projectId}`
          : `raise a ticket_submitbutton_${projectId}`;
    }
    return sourceVal;
  };

  const selectedSubComplaintTypeArr = Object.keys(modifyDataObj)?.length;
  const getUpdatedData = () => {
    let finalIssueComment = '';
    let finalDocArr = [];
    let initialDocArr = [];

    const document = [];
    fileData.forEach((item) => {
      document.push({
        nm: item.name,
        url: item.url,
      });
    });
    let cancellationPrefix = '';
    if (showCancellationReason && cancellationReason) {
      cancellationPrefix = `Reason: ${cancellationReason}\n`;
    }

    let subComplaintComment = '';
    if (modifyDataObj && selectedSubComplaintTypeArr > 0) {
      Object.keys(modifyDataObj)?.forEach((key) => {
        const { selectedOption, comment, attachments } = modifyDataObj[key];
        subComplaintComment += `\n${key}:`;
        if (selectedOption) {
          subComplaintComment += `\n Customization: ${selectedOption || ''}`;
        }
        if (comment) {
          subComplaintComment += `\n Description: ${comment || ''}\n`;
        } else {
          subComplaintComment += `\n`;
        }

        if (attachments && attachments?.length > 0) {
          attachments?.forEach((item) => {
            initialDocArr.push({
              nm: item.name,
              url: item.url,
            });
          });
        }
      });
    }

    if (
      modifyDataObj &&
      selectedSubComplaintTypeArr > 0 &&
      (!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0)
    ) {
      finalIssueComment = subComplaintComment;
      initialDocArr = [...initialDocArr];
    } else if (modifyDataObj && selectedSubComplaintTypeArr > 0 && selectedNotModifyTypeArr?.length > 0) {
      finalIssueComment = subComplaintComment;
      finalIssueComment += `\n${selectedNotModifyTypeArr?.join(', ')}:\n Description: ${issueComment || ''}`;
      if (document && document?.length > 0) {
        const updtArray = document.map((item) => ({
          nm: `${selectedNotModifyTypeArr?.join(', ')}: ${item.nm}`,
          url: item.url,
        }));
        initialDocArr = [...initialDocArr, ...updtArray];
      }
    } else if ((!modifyDataObj || selectedSubComplaintTypeArr === 0) && selectedNotModifyTypeArr?.length > 0) {
      finalIssueComment += `\n${selectedNotModifyTypeArr?.join(', ')}:\n Description: ${issueComment || ''}`;
      if (document && document?.length > 0) {
        const updtArray = document.map((item) => ({
          nm: `${selectedNotModifyTypeArr?.join(', ')}: ${item.nm}`,
          url: item.url,
        }));
        initialDocArr = [...updtArray];
      }
    } else if (showCancellationReason && cancellationReason) {
      if (cancellationReason === 'Others') {
        finalIssueComment = `\nReason: ${cancellationReason}\nDescription: ${issueComment}`;
      } else {
        finalIssueComment = `\nReason: ${cancellationReason}`;
      }
    } else if (isSalesComplaintStaff && complaintRegarding) {
      if (complaintRegarding.empid) {
        finalIssueComment += `\nEmp ID: ${complaintRegarding.empid}`;
      }
      if (complaintRegarding.role === 'Sales Representative') {
        finalIssueComment += `\nReason: ${complaintReason}`;
        if (complaintReason === 'Other') {
          finalIssueComment += `\nDescription: ${issueComment}`;
        }
      } else {
        finalIssueComment += `\nDescription: ${issueComment}`;
      }
    } else if (isRemoveListing && selectedBusinessToRemove) {
      finalIssueComment = `\nReason: ${removeListingReason}`;
      if (removeListingReason === 'Other') {
        finalIssueComment += `\nDescription: ${issueComment}`;
      }
    } else {
      finalIssueComment = issueComment;
    }
    initialDocArr = [...document];
    finalDocArr = [...initialDocArr];
    return { finalIssueComment, finalDocArr };
  };

  const handleSubmit = async (e) => {
    setHaveSubmitted(true);
    onClickEvent(`CS-Create Ticket Page`, 'Ticket Submit', 'Ticket Submit');
    e.preventDefault();
    try {
      if (projectId === 'csportal' || (projectId === 'genio' && selectedBusinessGenio?.mobile)) {
        const isRetentionVertical =
          selectedIssueSubIssue?.selectedIssue && ['ECS', 'ecs'].includes(selectedIssueSubIssue?.selectedIssue);

        const updatedDataObj = getUpdatedData();

        const updtVertical = hasJdMartVertical()
          ? 'JD MART CORPORATE'
          : selectedIssueSubIssue?.selectedIssue?.startsWith('UBL')
            ? 'GBL'
            : isRetentionVertical
              ? 'Retention'
              : bannerTicketCreateFlag
                ? 'Design Banner'
                : 'LISTING';

        const paramsObj = {
          vertical: updtVertical,
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm:
            selectedBusinessToRemove?.compname ||
            (projectId === 'csportal'
              ? selectedBusinessObj?.compname
              : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || ''),
          created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
          issue_type: selectedIssueSubIssue?.selectedIssue || '',
          issue_sub_type:
            (selectedIssueSubIssue?.selectedSubIssue && issuesDisplayObj?.[selectedIssueSubIssue?.selectedSubIssue]) ||
            '',
          issue_comment: updatedDataObj?.finalIssueComment || '',
          document: updatedDataObj?.finalDocArr || [],
          oid: '',
          orderid: '',
          city:
            projectId === 'csportal'
              ? selectedBusinessObj?.data_city
              : projectId === 'genio'
                ? selectedBusinessGenio?.city
                : '',
          docid:
            selectedBusinessToRemove?.docid ||
            (projectId === 'csportal'
              ? selectedBusinessObj?.docid
              : projectId === 'genio'
                ? selectedBusinessGenio?.docId
                : ''),
          src: projectId === 'csportal' ? 'business' : 'sales-genio',
          src_typ:
            empList.includes(profile.empCode) && projectId === 'genio'
              ? 'Genio – Market Research'
              : projectId === 'genio'
                ? selectedIssueSubIssue?.selectedOption === 'Client' || selectedBusinessGenio?.concern === 'client'
                  ? 'client'
                  : 'internal'
                : 'csportal',
          src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
          src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          projectId: projectId === 'csportal' ? 1 : '',
          parentId:
            projectId === 'csportal' ? selectedBusinessObj?.parentid || '' : selectedBusinessGenio?.parentId || '',
          compnm:
            selectedBusinessToRemove?.compname ||
            (projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusinessObj?.compname || ''),
          bannerTicketCreateFlag,
          bannerCta: queryParams?.get('bannerCta') || '',
          source: getSourceParamVal(isRetentionVertical),
          bypass_autoclassify:
            selectedIssueSubIssue?.selectedIssue?.trim().toLowerCase() === 'lead bank - b2b' ||
            selectedIssueSubIssue?.selectedIssue?.trim().toLowerCase() === 'book appointment' ||
            isRemoveListing ||
            isSalesComplaintStaff ||
            [
              'Business is Closed',
              'Money Problem/Not Interested',
              'Not Getting enough business/Poor Leads',
              'Wrong Promise made by Sales Person',
              'Money Deducted by mistake/Bank Issues',
              'Bought a New Package(Stop Old One)',
              'Poor Service',
              'Others',
            ].includes(cancellationReason)
              ? 1
              : 0,
          ...(projectId === 'genio' && {
            agent_mngr_id: profile?.reporteeCode,
            agent_id: profile?.empCode,
          }),
        };
        if (projectId === 'genio' && selectedIssueSubIssue?.selectedIssue === 'WEBSITE RELATED (JD OMNI)') {
          paramsObj.jdOmniFlag = 1;
          paramsObj.empCode = profile?.empCode || '';
          paramsObj.empCity = profile?.city || '';
        }
        if (isSalesComplaintStaff && complaintRegarding) {
          paramsObj.complaint_empid = complaintRegarding?.empid || '';
        }
        const res = await CreateTicket(paramsObj);
        if (res.errorCode === 0) {
          handleSetTicketsData(appDispatch, {
            ticketsData: res?.data || [],
          });
          setAlert({
            message: res?.result?.msg || 'Success!',
            status: true,
          });

          if (projectId === 'genio') {
            setGenioSuccessTicketId(res?.data?.[0]?.ticket_id || res?.result?.ticket_id || '');
          }

          if (cancellationReason === 'Business is Closed') {
            try {
              let docid = paramsObj?.parentId || '';
              if (!docid) {
                if (paramsObj?.docid) {
                  docid = `P${paramsObj?.docid.split(/P(.*)/s)[1]}`;
                }
              }
              const ticketDetails = res?.data?.[0] || res?.result || {};
              const reqBody = {
                parentid: docid,
                data_city: paramsObj?.city || '',
                userid: userDetails?.mobile || ticketDetails?.mobile || profile?.mobile || '',
                uname:
                  userDetails?.empname ||
                  userDetails?.fullName ||
                  ticketDetails?.alloc_empnm ||
                  profile?.full_name ||
                  '',
                ticketTime: ticketDetails?.cr_on || '',
                ticketId: ticketDetails?.ticket_id || '',
              };
              try {
                await sendCommunicationDB(reqBody);
              } catch (err) {
                console.log('err sendCommunicationDB', err);
              }

              const updatePayload = {
                empid: profile?.empCode || userDetails?.empcode,
                mb: paramsObj.mob || '',
                sid: '',
                ticket_id: ticketDetails?.ticket_id || '',
                docid: docid,
                status: selectedIssueSubIssue?.selectedIssue,
                subStatus: selectedIssueSubIssue?.selectedSubIssue,
                upId: 'backend',
                upNm: 'backend',
                update_data: {
                  client_concern: '',
                  disposition: 'TRANSFERRED',
                  disposition_comment: paramsObj.issue_comment || '',
                  resolution_type: '',
                  transfer_info: {
                    alloc_empid: '',
                    alloc_empnm: '',
                    category: 'CS',
                    cmt: '',
                    from: ticketDetails?.ticket_id || '',
                    time: ticketDetails?.cr_on || new Date().toISOString(),
                    to: '',
                    vertical: 'RETENTION',
                  },
                },
              };
              try {
                await saveTicketData(updatePayload);
              } catch (err) {
                console.log('err saveTicketData', err);
              }
            } catch (err) {
              console.log('err processing Business is Closed', err);
            }
          }
        } else {
          setAlert({
            message:
              (res?.message && typeof res?.message === 'string' && res?.message) ||
              (res?.result && res?.result?.msg) ||
              'Something Went Wrong!',
            status: false,
          });
        }
        // on genio success the next-action popup handles the navigation
        if (projectId !== 'genio' || res.errorCode !== 0) {
          if (projectId === 'genio' && token) {
            setTimeout(() => {
              if (onboardingRedirectUrl) {
                navigate(-1);
              } else {
                navigate('/genio', { replace: true });
              }
            }, 2000);
          } else {
            navigate(-1);
          }
        }
      } else if (projectId === 'genio') {
        setAlert({
          message: 'No Mobile number found in the contract. Validate with Database team.',
          status: false,
        });
      }
    } catch (err) {
      console.log('Error: ', err);
    }
    setFileData([]);
    handleResetFormFields();
    if (queryParams?.get('vertical') === 'leadDashBoard') {
      await clickTracker('CS-TicketCreate', 'leadDashBoard');
    } else if (queryParams?.get('raiseTicketTrackerID')) {
      await clickTracker(
        `${queryParams?.get('raiseTicketTrackerID')}_ticket_submit`,
        `${queryParams?.get('raiseTicketTrackerID')}_ticket`,
      );
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = 'ticketcreation_submission';
      const faqTypeVal = '';
      const othersData = [];
      const llTrdValue = raiseTicketTrackerID === 'gr' ? 'grievance' : raiseTicketTrackerID;
      const llTrd = raiseTicketTrackerID === 'landing' ? 'get_callback' : `issue_${llTrdValue}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    setHaveSubmitted(false);
  };

  const formFields = {
    textFields: {
      // parentId: {
      // id: 'parentId',
      // value: selectedBusiness.parentid || '',
      // label: 'Enter Parent Id',
      // },
      // companyName: {
      // id: 'companyName',
      // value: selectedBusiness?.compname || '',
      // label: 'Company Name',
      // },
      // city: {
      // id: 'city',
      // value: selectedBusiness.data_city || '',
      // label: 'City',
      // },
      // department: {
      // id: 'department',
      // value: 'CS-Regular',
      // label: 'Select Department',
      // }
    },
    dropDowns: {
      issue: {
        id: 'issue',
        label: 'Complaint',
        value: selectedIssueSubIssue.selectedIssue || 'Select Complaint',
        data: issueSubIssueData.issueData,
        isDisabled:
          issueSubIssueData?.subIssueData?.length > 1 &&
          selectedIssueSubIssue?.selectedIssue === issueTagging[queryParams?.get('key')] &&
          [
            'ECS',
            'ecs',
            'Banner-JDRR',
            'Mobile Banner',
            'Web Banner',
            'JDRR Certificate',
            'leads',
            'edit_my_business',
            'Contract-Information',
            'UBL',
            'LeadBank',
            'SmartAssistant',
            'bookAppointment',
          ].includes(queryParams?.get('key')),
        required: true,
      },
      subIssue: {
        id: 'subIssue',
        label: 'Complaint Type',
        value: selectedIssueSubIssue.selectedSubIssue || 'Select Complaint Type',
        data: issueSubIssueData.subIssueData,
        isDisabled: issueSubIssueData.subIssueData.length < 1,
        required: true,
      },
      cancellationReason: {
        id: 'cancellationReason',
        label: 'Reason for Cancellation',
        value: cancellationReason || 'Select Reason',
        data: cancellationReasons,
        isVisible: showCancellationReason,
        required: true,
      },
      ...(!selectedBusinessGenio?.concern &&
        projectId === 'genio' && {
          concern: {
            id: 'concern',
            label: 'Concern',
            value: selectedIssueSubIssue.selectedOption || 'Select Concern',
            data: options || [],
            isDisabled: false,
            required: true,
          },
        }),
    },
    descriptionField: {
      description: {
        id: 'description',
        value: issueComment,
        label: 'Description',
        required: true,
      },
    },
  };

  const handleSelectedIssue = (value) => {
    const subIssueRes = dispositionData.filter((each) => {
      if (each.issue_type === value) {
        return each;
      }
      return null;
    });
    const subIssueDataRes =
      subIssueRes &&
      subIssueRes[0] &&
      Object.keys(subIssueRes[0]).length > 0 &&
      subIssueRes[0]?.disp_obj &&
      Object.keys(subIssueRes[0]?.disp_obj).length > 0
        ? subIssueRes[0]?.disp_obj
        : {};
    const upd = Object.fromEntries(Object.entries(subIssueDataRes).map(([key, val]) => [key.trim(), val]));
    setIssuesDisplayObj(upd || {});
    setIssueSubIssueData({
      ...issueSubIssueData,
      subIssueData: ['Select Complaint Type', ...Object.keys(upd)],
    });
  };

  const handleIssueSelect = async (val, id) => {
    onClickEvent(`CS-Create Ticket Page-${id} Name`, val, val);
    setSearchTerm('');
    if (id === 'subIssue' && val === 'NO LEADS RECEIVED') {
      const noLeadsResp = await checkNoLeads(
        projectId === 'csportal' ? selectedBusinessObj?.parentid || '' : selectedBusinessGenio?.parentId || '',
        projectId === 'csportal'
          ? selectedBusinessObj?.data_city
          : projectId === 'genio'
            ? selectedBusinessGenio?.city
            : '',
        projectId === 'csportal' ? selectedBusinessObj?.docid : selectedBusinessGenio?.docId,
        getCookie('sid') || '',
        source,
      );
      if (noLeadsResp.leadscount > 0 && noLeadsResp?.paidRemarks === '') {
        setLeadDetails(noLeadsResp);
        setDisplayAlert(true);
      }
    }
    if (id === 'issue') {
      setShowSubComplaintType(false);
      setModifyDataObj({});
      setSelectedNotModifyTypeArr([]);
      setIssueComment('');
      setFileData([]);
      setCancellationReason('');
      setComplaintRegarding(null);
      setComplaintReason('');
      setSelectedBusinessToRemove(null);
      setRemoveListingReason('');
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedIssue: val, selectedSubIssue: '' });
      handleSelectedIssue(val);
    } else if (id === 'subIssue') {
      setSelectedIssueSubIssue({ ...selectedIssueSubIssue, selectedSubIssue: val.trim() });
      setComplaintRegarding(null);
      setComplaintReason('');
      setSelectedBusinessToRemove(null);
      setRemoveListingReason('');
      if (val.trim() !== 'STOP ECS') {
        setCancellationReason('');
      }
      setBannerTicketCreateFlag(
        selectedIssueSubIssue?.selectedIssue === 'MOBILE BANNER RELATED' &&
          ['DISPLAY ISSUES', 'DESIGN RELATED', 'LINK WITH WEBSITE'].includes(issuesDisplayObj?.[val.trim()]),
      );
      setIssueComment('');
      setFileData([]);
      if (
        ['WEB BANNER RELATED', 'MOBILE BANNER RELATED'].includes(selectedIssueSubIssue?.selectedIssue) &&
        issuesDisplayObj?.[val.trim()] === 'DESIGN RELATED'
      ) {
        const params = {
          category: 'cs',
          vertical: 'DESIGN BANNER',
          ticketCreator: 'business',
        };
        const res = await GetDispoDetials(params, 1, projectId);
        const issueItem =
          res && res?.length > 0 ? res?.find((issue) => issue.issue_type === 'MOBILE BANNER RELATED') : [];

        const issueSubTypes = issueItem ? issueItem?.issue_sub_type : [];
        setSubComplaintsData(issueSubTypes || []);
        setShowSubComplaintType(true);
      } else {
        setShowSubComplaintType(false);
        setModifyDataObj({});
        setSelectedNotModifyTypeArr([]);
      }
    } else if (id === 'concern') {
      setSelectedIssueSubIssue({
        ...selectedIssueSubIssue,
        selectedOption: val,
      });
    } else if (id === 'cancellationReason') {
      setCancellationReason(val);
    }
    setHaveSubmitted(false);
  };

  const deleteImage = (index) => {
    const tempFileData = [...fileData];
    tempFileData.splice(index, 1);
    setFileData(tempFileData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isRemoveListing =
    selectedIssueSubIssue.selectedIssue === 'CONTRACT RELATED' &&
    selectedIssueSubIssue.selectedSubIssue?.includes('REMOVE CONTRACT LISTING');

  const isReasonValid = showCancellationReason ? cancellationReason !== '' : true;
  const shouldShowDescription = !showCancellationReason || (showCancellationReason && cancellationReason === 'Others');
  const isCommentValid =
    isSalesComplaintStaff || isRemoveListing
      ? true
      : shouldShowDescription
        ? CheckingValidComment(issueComment) && checkEngChars(issueComment)
        : true;

  const isComplaintRegardingValid = isSalesComplaintStaff
    ? complaintRegarding !== null &&
      (complaintRegarding.role === 'Sales Representative'
        ? complaintReason !== '' &&
          (complaintReason === 'Other' ? CheckingValidComment(issueComment) && checkEngChars(issueComment) : true)
        : CheckingValidComment(issueComment) && checkEngChars(issueComment))
    : isRemoveListing
      ? selectedBusinessToRemove !== null &&
        removeListingReason !== '' &&
        (removeListingReason === 'Other' ? CheckingValidComment(issueComment) && checkEngChars(issueComment) : true)
      : true;

  const defaultEnableSubmitBtn =
    selectedIssueSubIssue.selectedIssue !== '' &&
    selectedIssueSubIssue.selectedIssue !== 'Select Complaint' &&
    selectedIssueSubIssue.selectedSubIssue !== '' &&
    selectedIssueSubIssue.selectedSubIssue !== 'Select Complaint Type' &&
    // CheckingValidComment(issueComment) &&
    (projectId === 'genio' && !selectedBusinessGenio?.concern
      ? selectedIssueSubIssue.selectedOption !== '' && selectedIssueSubIssue.selectedOption !== 'Select Concern' && true
      : true) &&
    isReasonValid &&
    isCommentValid &&
    isComplaintRegardingValid &&
    // (bannerTicketCreateFlag ? fileData && fileData.length > 0 : true) &&
    !loading &&
    !haveSubmitted;

  let enableSubmitButton;

  if ((!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0) && !showSubComplaintType) {
    enableSubmitButton = defaultEnableSubmitBtn;
  } else if (
    modifyDataObj &&
    selectedSubComplaintTypeArr > 0 &&
    (!selectedNotModifyTypeArr || selectedNotModifyTypeArr?.length === 0)
  ) {
    enableSubmitButton = enableSubComplaintBtn;
  } else if (modifyDataObj && selectedSubComplaintTypeArr > 0 && selectedNotModifyTypeArr?.length > 0) {
    enableSubmitButton = enableSubComplaintBtn && defaultEnableSubmitBtn;
  } else if ((!modifyDataObj || selectedSubComplaintTypeArr === 0) && selectedNotModifyTypeArr?.length > 0) {
    enableSubmitButton = defaultEnableSubmitBtn;
  }

  const handleKeyDown = (e, dropDownData, filteredData) => {
    const listData = filteredData || dropDownData?.data;
    const listLength = listData?.length || 0;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedItemIndex((prev) => Math.min(prev + 1, listLength - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedItemIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter' && focusedItemIndex !== -1) {
      const selectedItem = listData[focusedItemIndex];
      handleIssueSelect(selectedItem, dropDownData.id);
      setOpenDropdownIndex(null);
      setFocusedItemIndex(-1);
    }
  };
  const handleHealthCheck = async () => {
    const url = `https://wap.justdial.com/analytics/competitortrend?docid=${
      selectedBusiness?.docid || ''
    }&m=1&source=${source}&hide_header=1&el=1`;
    if (andriodSource.includes(source) || iosSource.includes(source)) {
      window.open(url);
    } else {
      window.location = url;
    }
  };

  return (
    <>
      {(projectId === 'csportal' && selectedBusinessObj?.docid) || projectId === 'genio' ? (
        <section
          className="cspage cslanding"
          style={{
            paddingBottom: source === 53 || source === '53' ? 250 : 0,
          }}
        >
          <div className="newticket_wpr p-20 pb-80">
            {Object.keys(formFields).map((formKey) =>
              ['textFields', 'descriptionField'].includes(formKey) && !showSubComplaintType
                ? Object.keys(formFields[formKey]).map((keyValue, idx) => {
                    if (formKey === 'descriptionField' && !shouldShowDescription) {
                      return null;
                    }
                    return (
                      <div className="group mt-20" key={idx}>
                        {formKey === 'descriptionField' && !displayAlert && (
                          <>
                            {isSalesComplaintStaff && (
                              <div className="complaint-regarding-section mb-20">
                                <div className={style.ComplaintRegardingTitle}>Who is your complaint regarding?*</div>
                                {dynamicComplaintRegardingList.map((person) => (
                                  <div
                                    key={person.id}
                                    className={`${style.ComplaintRegardingBox} ${complaintRegarding?.id === person.id ? style.Selected : ''}`}
                                    onClick={() => setComplaintRegarding(person)}
                                  >
                                    <div
                                      className={`${style.RadioCircle} ${complaintRegarding?.id === person.id ? style.Checked : ''}`}
                                    />
                                    <div className={style.PersonDetails}>
                                      <div className={style.PersonName}>{person.name}</div>
                                      {person.role ? (
                                        <div className={style.PersonRole}>{person.role}</div>
                                      ) : person.issue_sub_type ? (
                                        <div
                                          className={style.PersonRole}
                                        >{`Handled ${person.issue_sub_type} concern on ${person.date}`}</div>
                                      ) : null}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {isSalesComplaintStaff &&
                              complaintRegarding &&
                              (complaintRegarding.role === 'Sales Representative' ? (
                                <>
                                  <div className="complaint-reason-section">
                                    <div className={style.ReasonTitle}>
                                      Please tell us the reason for your complaint*
                                    </div>
                                    {complaintReasonList.map((reason, rIdx) => (
                                      <div
                                        key={rIdx}
                                        className={style.ReasonItem}
                                        onClick={() => setComplaintReason(reason)}
                                      >
                                        <div
                                          className={`${style.RadioCircle} ${complaintReason === reason ? style.Checked : ''}`}
                                        />
                                        <div className={style.ReasonText}>{reason}</div>
                                      </div>
                                    ))}
                                  </div>
                                  {complaintReason === 'Other' && (
                                    <>
                                      <label
                                        htmlFor={formFields[formKey][keyValue].id}
                                        className="description-label font14 mt-20"
                                      >
                                        Please share more details about your complaint*
                                      </label>
                                      <textarea
                                        style={{ width: '100%' }}
                                        value={formFields[formKey][keyValue].value}
                                        className="csexpndwp_textarea font12 fw400 color111"
                                        rows="4"
                                        cols="50"
                                        placeholder="Please describe your issue and our team will get back within 24-48 hours"
                                        onChange={(e) => {
                                          if (formFields[formKey][keyValue].id === 'description') {
                                            setIssueComment(e.target.value);
                                          }
                                        }}
                                      />
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <label
                                    htmlFor={formFields[formKey][keyValue].id}
                                    className="description-label font14"
                                  >
                                    Please share more details about your complaint*
                                  </label>
                                  <textarea
                                    style={{ width: '100%' }}
                                    value={formFields[formKey][keyValue].value}
                                    className="csexpndwp_textarea font12 fw400 color111"
                                    rows="4"
                                    cols="50"
                                    placeholder="Please describe your issue and our team will get back within 24-48 hours"
                                    onChange={(e) => {
                                      if (formFields[formKey][keyValue].id === 'description') {
                                        setIssueComment(e.target.value);
                                      }
                                    }}
                                  />
                                </>
                              ))}

                            {isRemoveListing && (
                              <div className="remove-listing-section mb-20" ref={businessListingRef}>
                                <div className={style.ComplaintRegardingTitle}>
                                  Which business listing do you want to remove from Justdial platform?*
                                </div>
                                {allBusinesses.length > 5 ? (
                                  <div className={`${style.FormGroupBox} form_group_box mt-10`}>
                                    <div className="form_group">
                                      <input
                                        className={`${style.Input} input font13 fw500 color111 pl-15 pr-45`}
                                        style={{ cursor: 'pointer' }}
                                        type="text"
                                        readOnly
                                        value={
                                          selectedBusinessToRemove
                                            ? `${selectedBusinessToRemove.compname} (${ChangeFirstLetterCapital(selectedBusinessToRemove.data_city)})`
                                            : ''
                                        }
                                        placeholder="Select Business Listing"
                                        onClick={() => setBusinessListingDropdownOpen(!businessListingDropdownOpen)}
                                      />
                                      <span
                                        role="presentation"
                                        onClick={() => setBusinessListingDropdownOpen(!businessListingDropdownOpen)}
                                        style={{
                                          transform: businessListingDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                          transition: '0.3s all',
                                          cursor: 'pointer',
                                        }}
                                        className={`${style.SelectArrow} select_arrow input_icon icon`}
                                      />
                                      <span className="inputbar" />
                                      {businessListingDropdownOpen && (
                                        <div className={`${style.InputDropdown} input__dropdown`}>
                                          <ul
                                            className={`${style.InputDroplist} input__droplist`}
                                            style={{ maxHeight: '260px' }}
                                          >
                                            {allBusinesses.map((business, bIdx) => (
                                              <li
                                                key={bIdx}
                                                role="presentation"
                                                className={`${style.InputDropdownItem} input__dropitem font14 fw500`}
                                                onClick={() => {
                                                  setSelectedBusinessToRemove(business);
                                                  setBusinessListingDropdownOpen(false);
                                                }}
                                              >
                                                {business.compname} ({ChangeFirstLetterCapital(business.data_city)})
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  allBusinesses.map((business, bIdx) => (
                                    <div
                                      key={bIdx}
                                      className={`${style.ComplaintRegardingBox} ${selectedBusinessToRemove?.parentid === business.parentid ? style.Selected : ''}`}
                                      onClick={() => setSelectedBusinessToRemove(business)}
                                    >
                                      <div
                                        className={`${style.RadioCircle} ${selectedBusinessToRemove?.parentid === business.parentid ? style.Checked : ''}`}
                                      />
                                      <div className={style.PersonDetails}>
                                        <div className={style.PersonName}>
                                          {business.compname} ({ChangeFirstLetterCapital(business.data_city)})
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                )}
                              </div>
                            )}

                            {isRemoveListing && selectedBusinessToRemove && (
                              <>
                                <div className="remove-listing-reason-section">
                                  <div className={style.ReasonTitle}>
                                    Please tell us why you want to remove your listing from Justdial*
                                  </div>
                                  {removeListingReasonList.map((reason, rIdx) => (
                                    <div
                                      key={rIdx}
                                      className={style.ReasonItem}
                                      onClick={() => setRemoveListingReason(reason)}
                                    >
                                      <div
                                        className={`${style.RadioCircle} ${removeListingReason === reason ? style.Checked : ''}`}
                                      />
                                      <div className={style.ReasonText}>{reason}</div>
                                    </div>
                                  ))}
                                </div>
                                {removeListingReason === 'Other' && (
                                  <>
                                    <label
                                      htmlFor={formFields[formKey][keyValue].id}
                                      className="description-label font14 mt-20"
                                    >
                                      Description*
                                    </label>
                                    <textarea
                                      style={{ width: '100%' }}
                                      value={formFields[formKey][keyValue].value}
                                      className="csexpndwp_textarea font12 fw400 color111"
                                      rows="4"
                                      cols="50"
                                      placeholder="Please describe your issue and our team will get back within 24-48 hours"
                                      onChange={(e) => {
                                        if (formFields[formKey][keyValue].id === 'description') {
                                          setIssueComment(e.target.value);
                                        }
                                      }}
                                    />
                                  </>
                                )}
                              </>
                            )}

                            {!isSalesComplaintStaff && !isRemoveListing && (
                              <>
                                <label htmlFor={formFields[formKey][keyValue].id} className="description-label font14">
                                  {`${formFields[formKey][keyValue].label}${
                                    formFields?.[formKey][keyValue]?.required ? '*' : ''
                                  } `}
                                </label>
                                <textarea
                                  style={{ width: '100%' }}
                                  value={formFields[formKey][keyValue].value}
                                  className="csexpndwp_textarea font12 fw400 color111"
                                  rows="4"
                                  cols="50"
                                  placeholder="Please describe your issue and our team will get back within 24-48 hours"
                                  onChange={(e) => {
                                    if (formFields[formKey][keyValue].id === 'description') {
                                      setIssueComment(e.target.value);
                                    }
                                  }}
                                />
                              </>
                            )}
                          </>
                        )}
                        {formKey === 'textFields' && (
                          <input
                            id={formFields[formKey][keyValue].id}
                            className={`inputMaterial font14 color1a1 ${
                              formFields[formKey][keyValue].id === 'city' ? 'capitalize' : ''
                            }`}
                            type="text"
                            required=""
                            autoComplete="off"
                            value={formFields[formKey][keyValue].value}
                            onChange={(e) => e}
                          />
                        )}

                        <span className="bar" />
                        {formFields[formKey][keyValue].id !== 'description' && (
                          <label htmlFor={formFields[formKey][keyValue].id} className="label-wrap font14">
                            {formFields[formKey][keyValue].label}
                          </label>
                        )}

                        {formFields[formKey][keyValue].id === 'description' &&
                          !CheckingValidComment(issueComment) &&
                          issueComment &&
                          issueComment.length > 3 && (
                            <span className="colorEC4 font12">{getCommentErrorMsg(issueComment)}</span>
                          )}

                        <span className="bar" />
                        {formFields[formKey][keyValue].id !== 'description' && (
                          <label htmlFor={formFields[formKey][keyValue].id} className="label-wrap font14">
                            {formFields[formKey][keyValue].label}
                          </label>
                        )}
                      </div>
                    );
                  })
                : Object.entries(formFields[formKey]).map(([dropDownKey, dropDownData], index) => {
                    const isOpen = openDropdownIndex === index;
                    const isVisible =
                      dropDownKey === 'cancellationReason'
                        ? dropDownData.isVisible
                        : dropDownKey === 'issue'
                          ? queryParams?.get('key') !== 'ECS'
                          : true;

                    if (!isVisible) return null;

                    const isSearchable = dropDownKey === 'issue' || dropDownKey === 'subIssue';
                    const filteredData = isSearchable
                      ? dropDownData.data
                          ?.slice(1)
                          .filter((item) => item.toLowerCase().includes(searchTerm.toLowerCase()))
                      : dropDownData.data;

                    return (
                      <div
                        ref={(el) => {
                          wrapperRefs.current[index] = el;
                        }}
                        key={index}
                        className={`${style.FormGroupBox} form_group_box mt-20`}
                      >
                        <div className="form_group">
                          <input
                            disabled={dropDownData.isDisabled}
                            className={`${style.Input} input font13 fw500 ${dropDownData.isDisabled ? 'color777' : 'color111'} pl-15 pr-45`}
                            style={{
                              cursor: dropDownData.isDisabled ? 'not-allowed' : isSearchable ? 'text' : 'pointer',
                            }}
                            type="text"
                            required
                            autoComplete="off"
                            value={
                              isSearchable && isOpen
                                ? searchTerm
                                : dropDownData.value.includes('Select')
                                  ? ''
                                  : dropDownData.id === 'concern' && concernOptionsDisplay[dropDownData.value]
                                    ? concernOptionsDisplay[dropDownData.value]
                                    : dropDownData.value
                            }
                            placeholder={isSearchable && isOpen ? 'Type to search...' : dropDownData.label}
                            readOnly={!isSearchable}
                            onChange={(e) => {
                              if (isSearchable) setSearchTerm(e.target.value);
                            }}
                            onClick={() => {
                              if (!dropDownData?.isDisabled) {
                                setOpenDropdownIndex((prev) => (prev === index ? null : index));
                                setFocusedItemIndex(-1);
                                if (isSearchable) setSearchTerm('');
                              }
                            }}
                            onKeyDown={(e) => handleKeyDown(e, dropDownData, isSearchable ? filteredData : null)}
                            tabIndex={0}
                          />
                          {isSearchable && isOpen && searchTerm && (
                            <span
                              role="presentation"
                              onClick={() => setSearchTerm('')}
                              style={{
                                position: 'absolute',
                                right: '35px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                fontSize: '18px',
                                color: '#777',
                                zIndex: 1,
                              }}
                            >
                              &times;
                            </span>
                          )}
                          <span
                            role="presentation"
                            onClick={() => {
                              if (!dropDownData?.isDisabled) {
                                setOpenDropdownIndex((prev) => (prev === index ? null : index));
                                setFocusedItemIndex(-1);
                                if (isSearchable) setSearchTerm('');
                              }
                            }}
                            style={{
                              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: '0.3s all',
                              cursor: 'pointer',
                            }}
                            className={`${style.SelectArrow} select_arrow input_icon icon`}
                          />
                          <span className="inputbar" />
                          <div
                            style={{ top: '-10px', left: '6px' }}
                            className={`${style.InputLabel} input_label font12 fw500 color777`}
                          >
                            {dropDownData.label}
                            <span className="colorEB5">*</span>
                          </div>
                          {isOpen && (
                            <div className={`${style.InputDropdown} input__dropdown`}>
                              <ul className={`${style.InputDroplist} input__droplist`} style={{ maxHeight: '260px' }}>
                                {(isSearchable ? filteredData : dropDownData.data)?.map((each, idx) => {
                                  const isFocused = idx === focusedItemIndex;
                                  return (
                                    <li
                                      key={idx}
                                      role="presentation"
                                      className={`${style.InputDropdownItem} input__dropitem font14 fw500`}
                                      style={{ backgroundColor: isFocused ? '#f0f0f0' : 'transparent' }}
                                      onClick={() => {
                                        handleIssueSelect(each, dropDownData.id);
                                        setOpenDropdownIndex(null);
                                        setFocusedItemIndex(-1);
                                      }}
                                      onMouseDown={(e) => {
                                        e.stopPropagation();
                                        handleIssueSelect(each, dropDownData.id);
                                        setOpenDropdownIndex(null);
                                        setFocusedItemIndex(-1);
                                      }}
                                      onMouseEnter={() => setFocusedItemIndex(idx)}
                                      onMouseLeave={() => setFocusedItemIndex(-1)}
                                      title={
                                        dropDownData.id === 'concern' && concernOptionsTooltip[each]
                                          ? concernOptionsTooltip[each]
                                          : ''
                                      }
                                    >
                                      {dropDownData.id === 'concern' && concernOptionsDisplay[each]
                                        ? concernOptionsDisplay[each]
                                        : each}
                                    </li>
                                  );
                                })}
                                {isSearchable && filteredData?.length === 0 && (
                                  <li className={`${style.InputDropdownItem} input__dropitem font14 color777`}>
                                    No results found
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }),
            )}
            {displayAlert && (
              <div className={`${style.Frame_144858}`}>
                <div className={`${projectId === 'csportal' ? style.Frame_2125770706 : style.Frame_2125770705}`}>
                  <div className={`${style.Contract_Details}`}>
                    You've recieved {leadDetails?.leadscount} leads this week!
                  </div>
                  {projectId === 'csportal' && (
                    <>
                      <div className={`${style.Contract_Details_nxt}`}>
                        To view all lead details on your dashboard click below
                      </div>
                      <div className={`${style.Frame_144845}`}>
                        <div
                          className={`${style.btn_text}`}
                          onClick={() => {
                            handleHealthCheck();
                          }}
                        >
                          Go to My Dashboard
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className={`${style.Frame_2125770706}`}>
                  <div className={`${style.Frame_2125770708}`}>
                    <div className={`${style.notif}`}>Stay Notified</div>
                  </div>
                  <div className={`${style.lead_notif}`}>You will get lead notifications on</div>
                  {projectId === 'csportal' && (
                    <div className={`${style.Frame_2125770712}`}>
                      <span className={`${style.num}`}>{leadDetails?.mobileFeeback}</span>
                      <span
                        className={`${style.change}`}
                        onClick={() => {
                          window.location.href = leadDetails?.url;
                        }}
                      >
                        Change
                      </span>
                    </div>
                  )}
                  <div className={`${style.Frame_144847}`} onClick={() => setDescriptionOpen((prev) => !prev)}>
                    <span className={`${style.txt}`}>Still Facing an Issue?</span>
                  </div>
                </div>
                {descriptionOpen && (
                  <>
                    {Object.keys(formFields).map((formKey) => {
                      if (['descriptionField'].includes(formKey) && !showSubComplaintType) {
                        return Object.keys(formFields[formKey]).map((keyValue, idx) => (
                          <div className="group mt-20" key={idx}>
                            {formKey === 'descriptionField' && (
                              <>
                                <label htmlFor={formFields[formKey][keyValue].id} className={`${style.upload}`}>
                                  {`${formFields[formKey][keyValue].label}${
                                    formFields?.[formKey][keyValue]?.required ? '*' : ''
                                  }`}
                                </label>

                                <textarea
                                  style={{ width: '100%' }}
                                  value={formFields[formKey][keyValue].value}
                                  className={`${style.textarea}`}
                                  rows="4"
                                  cols="50"
                                  placeholder="Please mention your issue"
                                  onChange={(e) => {
                                    if (formFields[formKey][keyValue].id === 'description') {
                                      setIssueComment(e.target.value);
                                    }
                                  }}
                                />
                              </>
                            )}
                          </div>
                        ));
                      }
                      return null;
                    })}

                    <div className="group phy_mandate_list uploadphoto mt-20 mb-15 mb-0">
                      <p className={`${style.upload}`}>Upload Attachments</p>

                      {fileData && fileData.length > 0
                        ? fileData.map((each, idx) => (
                            <span key={idx} className="uploaded_img mr-10 mb-10">
                              <img alt={each.name} src={each.url} />
                              <span className="uploaded_img_text font11 colorFFF">
                                <div
                                  onClick={() => deleteImage(idx)}
                                  role="button"
                                  tabIndex="0"
                                  aria-label="Delete image"
                                  className="ml-5"
                                >
                                  <img
                                    alt="delete_img"
                                    src="https://images.jdmagicbox.com/standard/cs_module/baf79d55c4951b13b60ebbb1c5f9e773.jpg"
                                  />
                                </div>
                              </span>
                              <span className="uploaded_overlay" />
                            </span>
                          ))
                        : loading && (
                            <span className="uploaded_img">
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                }}
                              >
                                <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                              </div>
                            </span>
                          )}

                      {(!bannerTicketCreateFlag ||
                        (bannerTicketCreateFlag && fileData && fileData.length < 1 && !loading)) && (
                        <span className="uploaded_img">
                          <span className="upload_type_wpr color393 font11">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleFileUpload}
                              onClick={(e) => {
                                e.target.value = null;
                              }}
                            />
                            <img
                              alt="addPhoto"
                              src="https://akam.cdn.jdmagicbox.com/images/icons/genio/gno_addphoto.svg"
                            />
                          </span>
                        </span>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
            {!displayAlert &&
              (!showSubComplaintType ? (
                <div className="group phy_mandate_list uploadphoto mt-20 mb-15 mb-0">
                  <p className="uploadtxt font14 pb-20">Upload Attachments</p>

                  {fileData && fileData.length > 0
                    ? fileData.map((each, idx) => (
                        <span key={idx} className="uploaded_img mr-10 mb-10">
                          <img alt={each.name} src={each.url} />

                          <span className="uploaded_img_text font11 colorFFF">
                            <div
                              onClick={() => deleteImage(idx)}
                              onKeyDown={() => {}}
                              className="ml-5"
                              role="button"
                              tabIndex="0"
                              aria-label="Delete image"
                              style={{ display: 'inline-block' }}
                            >
                              <img
                                alt="delete_img"
                                src="https://images.jdmagicbox.com/standard/cs_module/baf79d55c4951b13b60ebbb1c5f9e773.jpg"
                              />
                            </div>
                          </span>

                          <span className="uploaded_overlay" />
                        </span>
                      ))
                    : loading && (
                        <span className="uploaded_img">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                            }}
                          >
                            <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                          </div>
                        </span>
                      )}

                  {(!bannerTicketCreateFlag ||
                    (bannerTicketCreateFlag && fileData && fileData.length < 1 && !loading)) && (
                    <span className="uploaded_img">
                      <span className="upload_type_wpr color393 font11">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileUpload}
                          onClick={(e) => {
                            e.target.value = null;
                          }}
                        />
                        <img alt="addPhoto" src="https://akam.cdn.jdmagicbox.com/images/icons/genio/gno_addphoto.svg" />
                      </span>
                    </span>
                  )}
                </div>
              ) : (
                <SubComplaintType
                  subComplaintsData={subComplaintsData}
                  issueComment={issueComment}
                  setIssueComment={setIssueComment}
                  fileData={fileData}
                  deleteImage={deleteImage}
                  handleFileUpload={handleFileUpload}
                  selectedNotModifyTypeArr={selectedNotModifyTypeArr}
                  setSelectedNotModifyTypeArr={setSelectedNotModifyTypeArr}
                  setEnableSubComplaintBtn={setEnableSubComplaintBtn}
                  modifyDataObj={modifyDataObj}
                  setModifyDataObj={setModifyDataObj}
                />
              ))}
            <div className="mandatebtns fullwidthbtn">
              <button
                className={`${!enableSubmitButton ? 'mandatebtns_disabled' : 'mandatebtns_enable'} `}
                disabled={!enableSubmitButton}
                type="button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
      {genioSuccessTicketId !== null && (
        <TicketSuccessModal ticketId={genioSuccessTicketId} handleClosePopup={() => setGenioSuccessTicketId(null)} />
      )}
    </>
  );
}
